import React from 'react';
import { navigate } from 'gatsby';
import { useAnalytics } from '@carvana/analytics';
import { StyledContainer, StyledButton } from './styles';

const Support = () => {
  const { trackEvent } = useAnalytics();

  return (
    <StyledContainer>
      <StyledButton
        color="secondary"
        href="#"
        onClick={() => {
          trackEvent(
            'content_engagement',
            {
              clickstream: { engagement_type: 'browse_articles_link_click' }
            },
            ['clickstream']
          );

          navigate('/');
        }}
      >
        Browse Support Articles
      </StyledButton>
    </StyledContainer>
  );
};

export default Support;
